import type { DashboardWidgetInstance, StandaloneChartConfig } from './types';

/** Fields that affect Recharts rendering for dashboard viz widgets. */
export function chartDisplayFromConfig(
  c?: DashboardWidgetInstance['config']
): Partial<StandaloneChartConfig> {
  if (!c) return {};
  return {
    donutInnerRadiusPercent: c.donutInnerRadiusPercent,
    donutStartAngle: c.donutStartAngle,
    legendMode: c.legendMode,
    legendPlacement: c.legendPlacement,
    chartLabelFontSize: c.chartLabelFontSize,
    chartTextColor: c.chartTextColor,
    chartAxisLabelMode: c.chartAxisLabelMode,
    chartColorPaletteId: c.chartColorPaletteId,
    heatmapCellSizePx: c.heatmapCellSizePx,
  };
}
